import { auth } from "../../utils/utilities/firebase";
import {
  fetchSignInMethodsForEmail,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  getAuth,
} from "firebase/auth";
import { getAuthSignature } from "../../web3";
import messages from "../../utils/constants/messages";
import { utils } from "ethers";
import { getDecriptedEnv } from "../../actions/DataActions";
// // Firebase methods
// // Sign up
export const createAccount = async (walletAddress, library, keys, callBack) => {
  // create Account
  let signature = await getAuthSignature(walletAddress, library, keys);

  if (signature) {
    createUserWithEmailAndPassword(
      auth,
      walletAddress + "@gmail.com",
      signature
    )
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        callBack?.sucssess(user);
      })
      .catch((error) => {
        callBack?.onError("Failed to connect. Please try again.");
      });
  } else {
    callBack?.onError(messages.cnacledSigninRequest);
  }
};

// Sign in
export const signin = async (walletAddress, library, keys, callBack) => {
  let signature = await getAuthSignature(walletAddress, library, keys);

  if (signature) {
    signInWithEmailAndPassword(auth, walletAddress + "@gmail.com", signature)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        callBack?.sucssess(user);
      })
      .catch((error) => {
        if (error?.message) {
          callBack?.onError(error.message);
        } else {
          callBack?.onError("Failed to connect. Please try again.");
        }
      });
  } else {
    callBack?.onError(messages.cnacledSigninRequest);
  }
};

export const cardanoCreateAccount = async (walletAddress, callBack) => {
  // create Account
  let signature = window.btoa(walletAddress);

  if (signature) {
    createUserWithEmailAndPassword(
      auth,
      walletAddress + "@gmail.com",
      signature
    )
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        callBack?.sucssess(user);
      })
      .catch((error) => {
        callBack?.onError("Failed to connect. Please try again.");
      });
  } else {
    callBack?.onError(messages.cnacledSigninRequest);
  }
};

// Sign in
export const cardanoSignin = async (walletAddress, callBack) => {
  let signature = window.btoa(walletAddress);

  if (signature) {
    signInWithEmailAndPassword(auth, walletAddress + "@gmail.com", signature)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        callBack?.sucssess(user);
      })
      .catch((error) => {
        if (error?.message) {
          callBack?.onError(error.message);
        } else {
          callBack?.onError("Failed to connect. Please try again.");
        }
      });
  } else {
    callBack?.onError(messages.cnacledSigninRequest);
  }
};

export const disconnectFirebase = () => {
  if (getAuth().currentUser) {
    getAuth().signOut();
  }
};
export const checkSignInMethods = (walletAddress, library, keys, callBack) => {
  if (getAuth().currentUser) {
    callBack?.sucssess(getAuth().currentUser);
    return;
  }

  fetchSignInMethodsForEmail(auth, walletAddress + "@gmail.com")
    .then((providers) => {
      if (providers.length === 0) {
        createAccount(walletAddress, library, keys, callBack);
      } else {
        signin(walletAddress, library, keys, callBack);
      }

      // setTimeout(function () {
      //   Common.createToWallets(walletAddress, wallet);
      //   localStorage.setItem("wallet", wallet);
      //   setUser(walletAddress);
      //   setLoader(false);
      //   setOpen(false);

      //   setState((state) => ({
      //     ...state,
      //     isShowSuccess: true,
      //   }));
      // }, 3000);
    })
    .catch((error) => {
      console.log(error);
      if (error?.message) {
        callBack?.onError(error.message);
      } else {
        callBack?.onError("Failed to connect. Please try again.");
      }
    });
};

export const checkCardanoSignInMethods = async (walletAddress, callBack) => {
  fetchSignInMethodsForEmail(auth, walletAddress + "@gmail.com")
    .then((providers) => {
      if (providers.length === 0) {
        cardanoCreateAccount(walletAddress, callBack);
      } else {
        cardanoSignin(walletAddress, callBack);
      }
    })
    .catch((error) => {
      console.log(error);
      if (error?.message) {
        callBack?.onError(error.message);
      } else {
        callBack?.onError("Failed to connect. Please try again.");
      }
    });
};
